import{z as e}from"zod";const t=e.object({endpoint:e.url()}).strict();export{t as createWebhookDto};
//# sourceMappingURL=create-webhook.dto.mjs.map